import { ca } from '@cian/analytics';

import { getProductsData } from '../../../selectors/analytics';
import { IPromoInfo } from '../../../types/newbuilding/promoInfo';

export function trackShowPhone(customPageURL: string, promo: IPromoInfo, newbuildingId: number) {
  const { promoType, promoId } = promo;

  ca('eventSite', {
    name: 'oldevent',
    category: 'Phones',
    action: 'Open_jk_promotions',
    label: customPageURL,
    products: [getProductsData(newbuildingId, null, { label: promoType, promotion_id: promoId })],
  });
}
